import { IEmployeeBasicProfileModel } from '@/models/EmployeeModels';
import * as types from '@/mutation-types';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import Api from '@/Api';
import { IRootState, IEmployeeState } from '@/models/State';



const initState: IEmployeeState = {
    basicEmployeeProfile: {} as any,
};

const getters: GetterTree<IEmployeeState, IRootState> = {
    searchProfile: (state) => state.basicEmployeeProfile,
};

const mutations: MutationTree<IEmployeeState> = {
    [types.UPDATE_EMP_BASIC_PROFILE](state, payload: IEmployeeBasicProfileModel) {
        state.basicEmployeeProfile = payload;
    },
};

const actions: ActionTree<IEmployeeState, IRootState> = {
    getSearchProfile({commit}, id: number) {
        const url = id ? `/api/profile/${id}` : `/api/profile/`;
        Api.Instance
            .get(url)
            .then((response) => commit(types.UPDATE_EMP_BASIC_PROFILE, response.data));
    },
};

const namespaced: boolean = true;

export const EmployeeStore: Module<IEmployeeState, IRootState> = {
    namespaced,
    state: initState,
    getters,
    mutations,
    actions,
};
